module.exports = __webpack_public_path__ + "img/logo-white-text-vertical.62b37dd4.svg";